import React from 'react';
import { Link } from 'react-router-dom';
import AdminBotao from "./AdminBotao";

const OURO = { fontFamily: 'Outfit, sans-serif' };
const ZAP = 'https://wa.me/5566999584198?text=' + encodeURIComponent('Olá! Quero saber mais sobre o curso de segurança da Giraia.');

const PASSOS = [
  ['1', 'Cadastro rápido', 'Só nome, e-mail e WhatsApp.'],
  ['2', 'Aula', 'Texto simples, com letra grande e opção de ouvir.'],
  ['3', 'Quiz', 'Perguntas fáceis para fixar o que aprendeu.'],
  ['4', 'Certificado', 'Com seu nome e o selo da Giraia, para baixar em PDF.'],
];

const MODULOS = [
  ['1', 'Leis e Regras 2026', 'O que pode e o que não pode, quem precisa de habilitação e a responsabilidade dos pais.', true],
  ['2', 'Segurança na Prática', 'Equipamentos, ser visto no trânsito e como evitar quedas.', false],
  ['3', 'Pilotagem no Trânsito Urbano', 'Frenagem, ponto cego, cruzamentos e chuva.', false],
  ['4', 'Manutenção Básica', 'Pneu, freio e bateria: o que conferir antes de sair.', false],
  ['5', 'Aula Prática + Certificação', 'Treino presencial em Sorriso-MT com instrutora.', false],
];

export default function CursoLandingPage() {
  return (
    <div className="min-h-screen bg-[#141118] text-[#F2F0EA]" style={{ fontFamily: 'Manrope, sans-serif' }}>
      <header className="max-w-5xl mx-auto px-4 py-4 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2">
          <img src="/logo-giraia.jpg" alt="Giraia Bike Shop" className="w-14 h-14 rounded-full object-cover" />
          <span className="font-bold text-[#E2B84A] hidden sm:inline" style={OURO}>Giraia Bike Shop</span>
        </Link>
        <nav className="flex items-center gap-2 font-semibold">
          <Link to="/loja-publica" className="px-4 py-2 rounded-lg border border-[#E2B84A] text-[#E2B84A]">Loja</Link>
          <AdminBotao />
          <Link to="/curso/aluno" className="px-4 py-2 rounded-lg bg-[#E2B84A] text-[#141118]">Entrar</Link>
        </nav>
      </header>

      <section className="max-w-5xl mx-auto px-4 pt-8 pb-14 text-center">
        <img src="/logo-giraia.jpg" alt="" className="w-40 h-40 sm:w-52 sm:h-52 mx-auto mb-6 object-contain" />
        <p className="text-[#E2B84A] font-bold tracking-widest text-sm mb-3">CURSO DE SEGURANÇA · SORRISO-MT</p>
        <h1 className="text-4xl sm:text-6xl font-black leading-tight mb-5" style={OURO}>
          Seu filho anda de patinete, bike elétrica ou scooter?
        </h1>
        <p className="text-xl sm:text-2xl text-[#B8B3A8] max-w-2xl mx-auto mb-8">
          Aprenda as regras de 2026 e como pilotar com segurança. A primeira aula é <b className="text-[#F2F0EA]">grátis</b> e vem com <b className="text-[#F2F0EA]">certificado</b>.
        </p>
        <Link to="/curso/gratis" className="inline-block w-full sm:w-auto bg-[#E2B84A] text-[#141118] font-black text-2xl rounded-2xl px-10 py-5 shadow-lg" style={OURO}>
          Fazer a aula grátis
        </Link>
        <p className="mt-4 text-[#9A948A]">Leva uns 15 minutos. Pode fazer pelo celular.</p>
      </section>

      <section className="bg-[#1E1A24] py-14">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-3xl font-black text-center mb-10 text-[#E2B84A]" style={OURO}>Como funciona</h2>
          <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
            {PASSOS.map(function (p) {
              return (
                <div key={p[0]} className="bg-[#141118] rounded-2xl p-6 text-center">
                  <div className="w-14 h-14 mx-auto mb-3 rounded-full bg-[#E2B84A] text-[#141118] flex items-center justify-center text-2xl font-black" style={OURO}>{p[0]}</div>
                  <p className="text-xl font-bold mb-1">{p[1]}</p>
                  <p className="text-[#B8B3A8]">{p[2]}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 py-14">
        <div className="border-2 border-[#E2B84A] rounded-2xl p-6 sm:p-8">
          <h2 className="text-2xl sm:text-3xl font-black mb-4 text-[#E2B84A]" style={OURO}>Recado para os pais</h2>
          <p className="text-lg leading-relaxed mb-3">
            Pela lei, quando um menor de idade causa um acidente, <b>quem responde pelos prejuízos são os pais ou responsáveis</b>.
          </p>
          <p className="text-lg leading-relaxed text-[#B8B3A8]">
            Na aula grátis você descobre o que seu filho pode pilotar, onde pode andar e quais equipamentos usar. Vale a pena fazer junto com ele.
          </p>
        </div>
      </section>

      <section className="bg-[#1E1A24] py-14">
        <div className="max-w-3xl mx-auto px-4">
          <h2 className="text-3xl font-black text-center mb-2 text-[#E2B84A]" style={OURO}>O que o curso ensina</h2>
          <p className="text-center text-[#B8B3A8] mb-8">Comece pela aula grátis. Depois, se quiser, continue com os outros módulos.</p>
          <div className="space-y-3">
            {MODULOS.map(function (m) {
              return (
                <div key={m[0]} className="bg-[#141118] rounded-2xl p-5 flex gap-4 items-start">
                  <div className="w-12 h-12 shrink-0 rounded-full border-2 border-[#E2B84A] text-[#E2B84A] flex items-center justify-center text-xl font-black" style={OURO}>{m[0]}</div>
                  <div>
                    <p className="text-xl font-bold">
                      {m[1]}{' '}
                      {m[3] && <span className="ml-1 align-middle text-sm bg-[#E2B84A] text-[#141118] font-black rounded-full px-3 py-1">GRÁTIS</span>}
                    </p>
                    <p className="text-[#B8B3A8] text-lg">{m[2]}</p>
                  </div>
                </div>
              );
            })}
          </div>
          <Link to="/curso/gratis" className="block mt-8 text-center bg-[#E2B84A] text-[#141118] font-black text-xl rounded-2xl py-5" style={OURO}>
            Começar pela aula grátis
          </Link>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-4 py-14">
        <div className="bg-gradient-to-r from-[#2A2232] to-[#1E1A24] rounded-2xl p-6 sm:p-10 flex flex-col sm:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl sm:text-3xl font-black mb-2" style={OURO}>Também somos loja e oficina</h2>
            <p className="text-lg text-[#B8B3A8]">Bikes, bikes elétricas, scooters, peças, acessórios e revisão com quem entende.</p>
          </div>
          <div className="flex flex-col gap-3 w-full sm:w-auto">
            <Link to="/loja-publica" className="text-center bg-[#E2B84A] text-[#141118] font-bold text-lg rounded-xl px-8 py-4">Ver a loja</Link>
            <a href={ZAP} target="_blank" rel="noopener noreferrer" className="text-center border border-[#E2B84A] text-[#E2B84A] font-bold text-lg rounded-xl px-8 py-4">Falar no WhatsApp</a>
          </div>
        </div>
      </section>

      <footer className="border-t border-[#2D243F] py-8 px-4 text-center text-[#9A948A] text-sm space-y-2">
        <p className="text-[#F2F0EA] font-semibold">Giraia Bike Shop · Av. Ademar Raiter, 428, sala B, Centro Sul, Sorriso-MT</p>
        <p>WhatsApp (66) 99958-4198</p>
        <p>Curso livre de segurança. Não é documento oficial de trânsito e não substitui a habilitação.</p>
        <p>
          <a href="/privacidade.html" className="underline">Política de Privacidade</a>{' · '}
          <a href="/cancelamento.html" className="underline">Política de Cancelamento</a>
        </p>
      </footer>
    </div>
  );
}
